// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3wBlG","description":"PatientConsentPreview_description__1EQQr"};